module.exports = __webpack_public_path__ + "img/04.ecf89721.jpg";